import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { isEmpty, isUndefined } from 'lodash';
import { map } from 'rxjs';
import { LRC_TRANSACTIONS } from 'src/app/shared/constants/apis-list';
import { IUser } from 'src/app/shared/interfaces/User';
import { PurplWallet } from 'src/app/shared/interfaces/Wallets';
import { DataService, UserService } from 'src/app/shared/services';
import { toQueryParams } from 'src/app/shared/utils';

@Component({
  selector: 'app-incoming-funds',
  templateUrl: './incoming-funds.component.html',
  styleUrls: ['./incoming-funds.component.scss'],
})
export class IncomingFundsComponent implements OnInit {
  @Input() wallet: PurplWallet | null = null;
  @Input() walletIDs: any;

  user: IUser | null = null;
  INCOMING_INITIAL_FILTERS: {
    type?: any;
    user_id?: string;
    wallet_type_id?: string;
  };

  constructor(
    public dataService: DataService,
    public userService: UserService
  ) {
    this.user = this.userService.user as IUser;
    const partner = this.user?.partner;
    const partner_config = partner?.config;
    const partner_config_funds = partner_config?.cms?.funds?.wallet;

    this.INCOMING_INITIAL_FILTERS =
      partner_config_funds?.incoming_funds?.initial_filters;
  }

  TOTAL_FUNDS?: any;

  ngOnInit(): void {
    this.getTotalFunds(this.wallet!);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes: ', changes);
    if (
      !isEmpty(changes.wallet?.currentValue) &&
      isUndefined(changes.wallet?.previousValue)
    ) {
      this.getTotalFunds(this.wallet!);
    }
  }

  getTotalFunds(wallet: PurplWallet) {
    let params: HttpParams = new HttpParams();
    let URL_PARAMS = '';
    const default_params = `/_stats/?type=REMITTANCE,CASH_IN,TRANSFER&`;

    params = params.set('wallet_type_id', wallet?.wallet_type_id!);
    params = params.set('currency', wallet?.currency!);

    if (this.INCOMING_INITIAL_FILTERS) {
      URL_PARAMS =
        `/_stats/?${toQueryParams(this.INCOMING_INITIAL_FILTERS)}&` + params;
    } else {
      URL_PARAMS = default_params + params;
    }

    this.dataService
      .fetchData({
        apiUrl: LRC_TRANSACTIONS + URL_PARAMS,
        method: 'GET',
        contentType: 'application/json',
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        })
      )
      .subscribe((response: any) => {
        this.TOTAL_FUNDS = response?.total_amount;
      });
  }
}
